/** @jsx h */
import { h } from 'preact'

const AddIcon = ({
  style = {},
  fill = '#000',
  stroke = '#000',
  width = '15',
  className = '',
  viewBox = '0 0 15 15'
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_add-icon ${className}`}
  >
    <g transform='translate(-504 -717)' stroke={stroke}>
      <rect
        width='1'
        height='15'
        stroke={stroke}
        transform='translate(511 717)'
      />
      <rect
        width='1'
        height='15'
        stroke={stroke}
        transform='translate(519 724) rotate(90)'
      />
    </g>
  </svg>
)

export default AddIcon
